import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import styles from './SearchSelect.module.css';

const cx = classNames.bind(styles);


function SearchSelect({ require, placeholder, value, onChange, label, disabled, dataMap, error, message }) {
    const refInput = useRef(null)
    const [dataSelect, setDataSelect] = useState()
    const [isShowValue, setIsShowValue] = useState(false)
    const onChangeTextSearch = (value) => {
        onChange(null, value)
    }
    const handleChooseValue = (code, name) => {
        onChange(code, name)
    }
    useEffect(() => {
        if (dataMap && dataMap.length > 0) {
            setDataSelect(dataMap);
        }
    }, [dataMap])

    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target !== refInput.current) {
                setIsShowValue(false)
            }
        }
        document.addEventListener('click', handleCloseOnClickOutSide)
        return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
    }, [])
    return (
        <div className={cx('search-select-wrapper')}>
            <label className={cx('label', error && 'label-error')}>{label} {require && ' *'}</label>
            <input
                className={cx('input-search', error && 'input-error')}
                value={value ? value : ''}
                placeholder={placeholder ? placeholder : '...'}
                onChange={e => onChangeTextSearch(e.target.value)}
                onFocus={() => setIsShowValue(true)}
                ref={refInput}
                disabled={disabled}
            />
            {error && <p className={cx('label-error', 'message-error')}>{message}</p>}
            {isShowValue && (
                <div className={cx('modal-value-search')}>
                    <ul className={cx('list-value')}>
                        {dataSelect && dataSelect.length > 0 ? (
                            dataSelect.map((item, index) => {
                                return (
                                    <li key={index} className={cx('item-value')} onClick={e => handleChooseValue(item.code, item.name)}>{item.name}</li>
                                )
                            })
                        ) : <></>
                        }
                    </ul>
                </div>
            )}
        </div>
    )
}

export default SearchSelect;